/**
 * Collection card color swatches — swap card image to the selected color variant.
 */
(function () {
  function applyImage(img, src, srcset, width, height, alt) {
    img.removeAttribute('srcset');
    img.src = src;
    if (srcset) img.setAttribute('srcset', srcset);
    if (width) img.setAttribute('width', width);
    if (height) img.setAttribute('height', height);
    if (alt) img.alt = alt;
  }

  function onColorSwatchClick(event) {
    var swatch = event.target.closest('.color-swatches__item');
    if (!swatch) return;

    // Stop Dawn's stretched card link from navigating
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    var imageSrc = swatch.getAttribute('data-image-src');
    if (!imageSrc) return;

    var wrap = swatch.closest('.color-swatches');
    var card = swatch.closest('.card-wrapper');
    if (!card) return;

    var media = card.querySelector('.card__media .media');
    if (!media) return;

    var primaryImg = media.querySelector('img');
    if (!primaryImg) return;

    // Clear srcset first. Once a candidate is chosen, assigning src then
    // srcset often leaves the previous photo on screen.
    applyImage(
      primaryImg,
      imageSrc,
      swatch.getAttribute('data-image-srcset'),
      swatch.getAttribute('data-image-width'),
      swatch.getAttribute('data-image-height'),
      swatch.getAttribute('data-image-alt')
    );

    // Swap the back/hover image to this colorway's next gallery photo.
    var hoverSrc = swatch.getAttribute('data-hover-src');
    var secondaryImg = media.querySelector('img + img');

    if (hoverSrc) {
      media.classList.remove('is-color-selected');
      if (!secondaryImg) {
        secondaryImg = document.createElement('img');
        secondaryImg.className = 'motion-reduce';
        secondaryImg.loading = 'lazy';
        var sizes = primaryImg.getAttribute('sizes');
        if (sizes) secondaryImg.setAttribute('sizes', sizes);
        media.appendChild(secondaryImg);
      }
      applyImage(
        secondaryImg,
        hoverSrc,
        swatch.getAttribute('data-hover-srcset'),
        swatch.getAttribute('data-hover-width'),
        swatch.getAttribute('data-hover-height'),
        swatch.getAttribute('data-hover-alt')
      );
    } else {
      media.classList.add('is-color-selected');
      if (secondaryImg) secondaryImg.remove();
    }

    var productUrl = swatch.getAttribute('data-product-url');
    if (productUrl) {
      card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
        var href = link.getAttribute('href') || '';
        if (href.indexOf('/products/') === -1) return;
        link.setAttribute('href', productUrl);
      });
    }

    if (wrap) {
      wrap.querySelectorAll('.color-swatches__item').forEach(function (el) {
        el.classList.remove('is-selected');
        el.setAttribute('aria-pressed', 'false');
      });
    }
    swatch.classList.add('is-selected');
    swatch.setAttribute('aria-pressed', 'true');
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', onColorSwatchClick, true);
  });
})();
